import { BuildingCircularSiteMenuList } from "../utils/constants";
import { TableStructure } from "../components/TableStructure";
const List = [
  {
    fileStoreId: "49b59987-ba9f-4f69-bd69-4b422878d5a4",
    label: "DG(BLDG)'s Circular No. 8 of 2019-20",
    date: "19/01/2021",
    subject:
      "Retention fees for uc etc. as per IGR market value Circular No.8 of 2020-21",
  },
  {
    fileStoreId: "d3ebaff6-99da-4e8b-a11c-ff63b370348c",
    label: "DG(BLDG)'s Circular No. 7 of 2019-20",
    date: "	16/12/2020",
    subject:
      "Intimation to Thika Controller regarding uc on thika land Circular No.7 of 2020-21",
  },
  {
    fileStoreId: "71ffd4bf-797e-4d78-adf7-c10746a41820",
    label: "DG(BLDG)'s Circular No. 6 of 2019-20",
    date: "30/09/2020",
    subject:
      "Guide to provide Tree Cover under rule 144(2) Circular No.6 of 2020-21",
  },
  {
    fileStoreId: "2b01c735-e242-42d4-b12a-9dde3c7d71e6",
    label: "DG(BLDG)'s Circular No. 5 of 2019-20",
    date: "17/07/2020",
    subject:
      "Validity of extention of sanction plan due to COVID19 lockdown Circular No.5 of 2020-21",
  },

  {
    fileStoreId: "91545206-c77e-4172-8b3f-dc73b7ca0c8b",
    label: "DG(BLDG)'s Circular No. 4 of 2019-20",
    date: "17/07/2020",
    subject:
      "Stop work notice to inform Kolkata Police through email Circular No.4 of 2020-21",
  },

  {
    fileStoreId: "6d222f5f-f150-4aca-b790-995da1537151",
    label: "DG(BLDG)'s Circular No. 3 of 2019-20",
    date: "29/06/2020",
    subject:
      "Guidelines for prevention of mosquito breeding at construction site Circular No.3 of 2020-21",
  },
  {
    fileStoreId: "1bf671d2-e914-4517-b844-690506c5747b",
    label: "DG(BLDG)'s Circular No. 2 of 2019-20",
    date: "	13/06/2020",
    subject: "Physical land area Circular No.2 of 2020-21",
  },
];

const Building_Sanction_Circular_2020_21 = () => (
  <TableStructure
    list={List}
    columnNo={3}
    leftMenuList={BuildingCircularSiteMenuList}
    title="Circular :: 2020-21"
    longMenuList={true}
  />
);

export default Building_Sanction_Circular_2020_21;
